import React from 'react';
import './Cart.css';

const Cart = ({ exercise, handleTimeRequired }) => {
    const { id, category, name, details, reqTime, img } = exercise;
    return (
        <div className="col-md-4 single-programme">
            <div className="pro-img">
                <img className='img-fluid img-thumbnail rounded' src={img} alt="" />
            </div>
            <div className="pro-details">
                <h3>{name}</h3>
                <p>{details.slice(0, 100)}...</p>
                <h5 className='fw-bold'>For Age: 20-25</h5>
                <h6 className='mb-3'>Time Required: <span id='required-time'>{reqTime}</span>s</h6>
            </div>
            <div className="pro-btn">
                <button onClick={() => handleTimeRequired(exercise)} className="btn btn-primary">Add to List</button>
            </div>
        </div>
    );
};

export default Cart;